export default "__VITE_ASSET__BDPysLbY__"